import Typography from '~/shared/components/Typography';

import VolumeInfoCard from './VolumeInfoCard';
import VolumeCardSkeleton from './VolumeCardSkeleton';

import type { Volume } from '~/shared/types/api';

export type VolumeType = 'matching' | 'exception' | 'potential';

interface VolumeGridProps {
  volumes: Volume[];
  searchQuery: string;
  onCreateException?: (volumeId: string) => void;
  onRemoveException?: (volumeId: string, volumeName?: string) => void;
  volumeType?: VolumeType;
  isLoading?: boolean;
}

export default function VolumeGrid({
  volumes,
  searchQuery,
  onCreateException,
  onRemoveException,
  volumeType,
  isLoading = false,
}: VolumeGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-[5px]">
        {Array.from({ length: 6 }).map((_, index) => (
          <VolumeCardSkeleton key={index} volumeType={volumeType} />
        ))}
      </div>
    );
  }

  if (volumes.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <Typography variant="p3-reg" color="text-gray-500">
          {searchQuery.trim() ? 'No volumes match your search' : 'No volumes found'}
        </Typography>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-[5px]">
      {volumes.map((volume) => (
        <VolumeInfoCard
          key={volume.volumeId}
          volume={volume}
          onCreateException={onCreateException}
          onRemoveException={onRemoveException}
          volumeType={volumeType}
        />
      ))}
    </div>
  );
}
